
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
    TRAVELFORM_ACTION,
    ALL_TRAVELFORM,
    ADD_TRAVELFORM,
    FETCH_TRAVELFORM,
    DELETE_TRAVELFORM_SUCCESS,
    DELETE_TRAVELFORM_FAILURE,
    UPDATE_TRAVELFORM,
    MAIL_TRAVELFORM

} from 'Actions/types';


export const allTravelForm = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: TRAVELFORM_ACTION });
        return axios.get(AppConfig.apiurl+'/api/gettravelform', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_TRAVELFORM, payload: allroles });
            
        });
    }
}

export const studentsTravelForm = (id) => async (dispatch) =>{
    var payload = {      
       "id": id
    };   

    dispatch({ type: TRAVELFORM_ACTION });
    
    try {
        const response = await axios.post(AppConfig.apiurl+'/api/getstudenttravelform', payload, { headers: AuthHeader.header });
        const alltravel = response.data.data;
        
        dispatch({ type: ALL_TRAVELFORM, payload: alltravel });          
        return Promise.resolve(alltravel);
    } catch (error) {
        console.error('Error fetching student travel form:', error);
        return Promise.reject(error);
    }
};


export const addTravelForm = (teamval, sepmore, leavecnt) => async (dispatch) =>{
 
     const travelwith=teamval.target.travelwith.value;
     
    var payload={
       
        "student":teamval.target.student.value,
        "checkoutdate":teamval.target.checkoutdate.value,
        "checkouttime":teamval.target.checkouttime.value,
        "checkindate":teamval.target.checkindate.value,
        "checkintime":teamval.target.checkintime.value,        
        "travelwith":teamval.target.travelwith.value,
        "transport":teamval.target.transport.value,
        "leavecount":leavecnt,
        "sepmore":sepmore      

    }

    for (let i = 0; i<sepmore; i++) {        
        
        var sepday='sepday_'+i;            
        var sedyval=teamval.target[sepday].value;
        var sepopt='sepopt_'+i;            
        var seoptval=teamval.target[sepopt].value;
        var septravel='septravel_'+i;            
        var setrvalval=teamval.target[septravel].value;
       
        if(sedyval!=""){
            var adval=i+1;
            var sepdayadd='sepday_'+adval;  
            var sepoptadd='sepopt_'+adval; 
            var septraveladd='septravel_'+adval;        
            payload[sepdayadd]=sedyval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;
        }

    }

    if(travelwith=='Others'){
        payload['personname']=teamval.target.personname.value;
    }else{
        payload['personname']="";
    }

    

    dispatch({ type: TRAVELFORM_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addtravelform', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allTravelForm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_TRAVELFORM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Travel form not added');
         }            
         return Promise.resolve(resdata);
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
     
}



export const fetchTravelForm = (cttfID) => async (dispatch) => {
	
	var payload={
		"id":cttfID

	}
	// console.log(payload);
	  dispatch({ type: TRAVELFORM_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/detailscttravelform', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resvalue=resdata.data;	
                //console.log(resvalue);
               
				dispatch({ type: FETCH_TRAVELFORM, payload:resvalue}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

}


export const updateTravelForm = (teamval, sepmore, leavecnt) => async (dispatch) => {
   
    var payload={
       "travelid":teamval.target.upttravelid.value,
       "uptstudid":teamval.target.uptstudid.value, 
       "uptcheckoutday":teamval.target.checkoutdate.value,
       "uptcheckouttime":teamval.target.checkouttime.value,      
       "studcheckindate":teamval.target.checkindate.value,
       "studcheckintime":teamval.target.checkintime.value,
       "studcheckinenter":teamval.target.studcheckinenter.value,
       "uptleavecount":leavecnt,
       "Uptopttot":sepmore
    }

    for (let i = 0; i<sepmore; i++) {        
        
        var sepday='sepday_'+i;            
        var sedyval=teamval.target[sepday].value;
        var sepopt='sepopt_'+i;            
        var seoptval=teamval.target[sepopt].value;
        var septravel='septravel_'+i;            
        var setrvalval=teamval.target[septravel].value;
       
        if(sedyval!=""){
            var adval=i+1;
            var sepdayadd='optday_'+adval;  
            var sepoptadd='sepopt_'+adval; 
            var septraveladd='opttravel_'+adval;        
            payload[sepdayadd]=sedyval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;
        }

    }

     dispatch({ type: TRAVELFORM_ACTION });
    axios.post(AppConfig.apiurl+'/api/updatecheckintravelform', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
                allTravelForm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: UPDATE_TRAVELFORM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
 }


export const deleteTravelform = (cttfID) => async (dispatch) => {
	
	var payload={
		"id":cttfID
	}
	
	  dispatch({ type: TRAVELFORM_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/deletetravelform', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;
				if(resdata.status===1){
					allTravelForm()(dispatch);
					NotificationManager.success(resdata.message);               
					dispatch({ type: DELETE_TRAVELFORM_SUCCESS});
				}else{
					NotificationManager.error(resdata.message); 
					dispatch({ type: DELETE_TRAVELFORM_FAILURE});			   
				}
					
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}



export const mailTravelForm = (teamval) => async (dispatch) =>{
    var payload={
        "id":teamval.target.travelid.value,
        "emails":teamval.target.parentmail.value
      
    }
    
    dispatch({ type: TRAVELFORM_ACTION });
    return axios.post(AppConfig.apiurl+'/api/parentmailtravelform', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            console.log(resdata);
            if(resdata.status===1){
               allTravelForm()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type:  MAIL_TRAVELFORM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Travel form not added');
         }            
         return Promise.resolve(resdata);
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
     
}